import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { IEstimateLineItemData } from "common/records/EstimateLineItem";
import { Nullable } from "common/types";

export const RECEIVE_ESTIMATE_LINE_ITEM = "@estimateLineItems/RECEIVE_ESTIMATE_LINE_ITEM";
export const DUPLICATE_ESTIMATE_LINE_ITEM = "@estimateLineItems/DUPLICATE_ESTIMATE_LINE_ITEM";
export const UPDATE_ESTIMATE_LINE_ITEM_TOTALS = "@estimateLineItems/UPDATE_ESTIMATE_LINE_ITEM_TOTALS";
export const DECREMENT_ESTIMATE_LINE_ITEM_UNSAVED_ID = "@estimateLineItems/DECREMENT_ESTIMATE_LINE_ITEM_UNSAVED_ID";
export const SET_ESTIMATE_LINE_ITEM_BY_ID = "@estimateLineItems/SET_ESTIMATE_LINE_ITEM_BY_ID";
export const PUSH_ESTIMATE_LINE_ITEM_DOCUMENT_ID = "@estimateLineItems/PUSH_ESTIMATE_LINE_ITEM_DOCUMENT_ID";
export const PUSH_ESTIMATE_LINE_ITEM_IMAGE_ID = "@estimateLineItems/PUSH_ESTIMATE_LINE_ITEM_IMAGE_ID";
export const REMOVE_ESTIMATE_LINE_ITEM_DOCUMENT_ID = "@estimateLineItems/REMOVE_ESTIMATE_LINE_ITEM_DOCUMENT_ID";
export const REMOVE_ESTIMATE_LINE_ITEM_IMAGE_ID = "@estimateLineItems/REMOVE_ESTIMATE_LINE_ITEM_IMAGE_ID";
export const RESET_DUPLICATE_SOURCE_TO_CLONE_MAP = "@estimateLineItems/RESET_DUPLICATE_SOURCE_TO_CLONE_MAP";

export const EstimateLineItemActions = {
  receiveEstimateLineItem: (estimateLineItem: Partial<IEstimateLineItemData>) =>
    createAction(RECEIVE_ESTIMATE_LINE_ITEM, { estimateLineItem }),
  /**
   * Duplicates an estimate line item and its options to a new group
   *
   * @param sourceLineItemId The id of the line item to duplicate
   * @param targetGroupId The id of the group to add the duplicated line item to
   */
  duplicateEstimateLineItem: (sourceLineItemId: number, targetGroupId: number) =>
    createAction(DUPLICATE_ESTIMATE_LINE_ITEM, { sourceLineItemId, targetGroupId }),
  updateTotals: (estimateLineItemId: Nullable<number>) =>
    createAction(UPDATE_ESTIMATE_LINE_ITEM_TOTALS, { estimateLineItemId }),
  decrementUnsavedId: () => createAction(DECREMENT_ESTIMATE_LINE_ITEM_UNSAVED_ID),
  setEstimateLineItemById: (estimateLineItemId: number, estimateLineItem: Partial<IEstimateLineItemData>) =>
    createAction(SET_ESTIMATE_LINE_ITEM_BY_ID, { estimateLineItemId, estimateLineItem }),
  pushDocumentId: (estimateLineItemId: number, documentId: number) =>
    createAction(PUSH_ESTIMATE_LINE_ITEM_DOCUMENT_ID, { estimateLineItemId, documentId }),
  pushImageId: (estimateLineItemId: number, imageId: number) =>
    createAction(PUSH_ESTIMATE_LINE_ITEM_IMAGE_ID, { estimateLineItemId, imageId }),
  removeDocumentId: (estimateLineItemId: number, documentId: number) =>
    createAction(REMOVE_ESTIMATE_LINE_ITEM_DOCUMENT_ID, { estimateLineItemId, documentId }),
  removeImageId: (estimateLineItemId: number, imageId: number) =>
    createAction(REMOVE_ESTIMATE_LINE_ITEM_IMAGE_ID, { estimateLineItemId, imageId }),
  /**
   * Clears the transient source→clone line-item id map. Dispatched at the start of an estimate-level
   * duplicate so the map only holds the current cascade's mappings for the attachment re-upload thunk.
   */
  resetDuplicateSourceToCloneMap: () => createAction(RESET_DUPLICATE_SOURCE_TO_CLONE_MAP),
};

export type EstimateLineItemActions = ActionsUnion<typeof EstimateLineItemActions>;
